import { formActions, useAppDispatch, useAppSelector } from '../../data/store';
import React, { ChangeEvent } from 'react';
import { getRandomIcons } from '../../domain/icons-provider';

const FormIconsNumber = () => {

    const dispatch = useAppDispatch();

    const icons = useAppSelector(store => store.form.icons);
    const iconsData = useAppSelector(store => store.root.iconsData);
    const category = useAppSelector(store => store.root.category);

    const onChangeHandler = async (evt: ChangeEvent<HTMLSelectElement>) => {
        const updatedValue = Number(evt.target.value) || 1;
        const icons = await getRandomIcons(iconsData, category, updatedValue);
        dispatch(
            formActions.main({
                icons,
            })
        );
    };

    return (
        <div className="mr-10 mb-4">
            <label htmlFor="icons-number-select" className="mb-2 inline-block">Icons Number</label>
            <select
                id="icons-number-select"
                className="border rounded px-4 py-2 block"
                value={ icons.length }
                onChange={ onChangeHandler }>
                <option value="1">1 Item</option>
                <option value="2">2 Items</option>
                <option value="3">3 Items</option>
                <option value="4">4 Items</option>
                <option value="5">5 Items</option>
                <option value="6">6 Items</option>
                <option value="7">7 Items</option>
                <option value="8">8 Items</option>
                <option value="9">9 Items</option>
                <option value="10">10 Items</option>
            </select>
        </div>
    )
};

export default FormIconsNumber;